import type { QueryClient } from '@tanstack/react-query'
import { orpc } from './api.ts'

export const meQuery = orpc.account.me.queryOptions({
  retry: false,
  staleTime: 60_000,
  gcTime: 60 * 60_000,
})

/** The signed-in user, or null. Network and server errors still throw. */
export function currentUser(queryClient: QueryClient) {
  return queryClient.ensureQueryData(meQuery)
}

/** Only app paths survive a round trip through ?next=. */
export function safeNext(next: unknown): string {
  return typeof next === 'string' && next.startsWith('/') && !next.startsWith('//') ? next : '/'
}
